module.exports = __webpack_public_path__ + "static/media/courier.2502ac5d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/courier.ttf
// module id = 410
// module chunks = 33